import React, { useEffect, useState } from "react";
import BlogPost from "crm/other/BlogPost";
import IndustryDetailTemplate from "pages/industries/IndustryDetailTemplate";
import { getBlogsBySlug } from "helpers/api/BlogService";

import { useParams, useLocation } from "react-router-dom";

export default function DynamicPage() {
    const { slug } = useParams<{ slug: string }>();
    const location = useLocation();

    const stateData = location.state as {
        type?: "blog" | "industry";
        data?: any;
    };

    const [type, setType] = useState<"blog" | "industry" | "notfound">("blog");
    const [data, setData] = useState<any>(null);

    useEffect(() => {
        // ✅ जर state मधून data आला असेल (fast navigation)
        if (stateData?.type && stateData?.data) {
            setType(stateData.type);
            setData(stateData.data);
            return;
        }

        // ❗ direct URL hit
        if (!slug) return;

        getBlogsBySlug(slug)
            .then((res) => {
                if (res?.success && res.result) {

                    // ✅ FINAL LOGIC (NO category)
                    if (res.result.isBlog === false) {
                        setType("industry");
                    } else {
                        setType("blog");
                    }

                    setData(res.result);
                } else {
                    setType("notfound");
                }
            })
            .catch(() => setType("notfound"));
    }, [slug, stateData]);

    if (type === "notfound") return <div>Not Found</div>;

    if (type === "industry") {
        return <IndustryDetailTemplate blogData={data} />;
    }

    return <BlogPost blogData={data} />;
}

